module.exports = __webpack_public_path__ + "static/img/QLD-14.8003cb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QLD-14.jpg
// module id = TkbV
// module chunks = 0